import { useEffect } from "react";
import { Alert } from "@mantine/core";

export function LegacyHistoricalReportUnavailable({
  onError,
}: {
  onError?: () => void;
}) {
  useEffect(() => {
    onError?.();
  }, [onError]);
  return (
    <Alert
      color="red"
      title="Historical report unavailable"
      role="alert"
      data-report-pagination-error="true"
    >
      A preserved report graphic could not be verified. Reload the saved
      reconstruction before reviewing or generating this report.
    </Alert>
  );
}
